import { render, staticRenderFns } from "./ProviderDetailsStatic.vue?vue&type=template&id=004047bc&scoped=true&"
import script from "./ProviderDetailsStatic.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailsStatic.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDetailsStatic.vue?vue&type=style&index=0&id=004047bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004047bc",
  null
  
)

export default component.exports